<template>
  <b-modal
    id="modalInfo"
    v-model="isOpen"
    modal-class="modalInfo"
    :title="
      $t('label_evaluation_evidencesRequested_evidenceNotAvailable_button')
    "
  >
    <div>
      <b-form-group
        id="comment"
        :label="
          $t(
            'label_evaluation_evidencesRequested_evidenceJustification_description'
          )
        "
        label-for="comment"
      >
        <b-input-group>
          <b-textarea id="comment" v-model="comment.comment" />
        </b-input-group>
      </b-form-group>
    </div>
    <div slot="modal-footer" class="w-100" style="text-align: center">
      <div class="d-flex justify-content-around">
        <b-row>
          <b-col>
            <b-btn @click="isOpen = false">
              {{
                $t(
                  "label_evaluation_requirementEvaluation_evidenceResubmission_warning_cancel"
                )
              }}
            </b-btn>
          </b-col>
          <b-col>
            <b-button
              variant="primary"
              :disabled="!comment.comment"
              @click="postComment()"
            >
              {{ $t("label_evaluation_requirementEvaluation_post_button") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "EvaluationOrganizationEvidenceJustificationModal",
  props: ["requirement", "showModal", "account"],
  data() {
    return {
      comment: {},
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.showModal;
      },
      set(newValue) {
        this.$emit("update:showModal", newValue);
      },
    },
    ...mapGetters(["getUserAccount"]),
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    async postComment() {
      let valuesToPush = {};
      let baseCommentPath = "evidences.comments";
      let comment = cloneDeep(this.comment);
      comment["account"] = { account: this.getUserAccount };
      comment["date"] = new Date().toLocaleDateString("en-US");
      valuesToPush[baseCommentPath] = comment;
      await this.$store.dispatch("updateEvaluation", {
        valuesToPush: valuesToPush,
      });
      this.$emit(
        "newData",
        "label_evaluation_evidencesRequested_status_inProgress"
      );
      this.comment = {};
      this.isOpen = false;
    },
  },
};
</script>

